import { useEffect, useState } from "react";
import { Phone, MessageCircle, MapPin } from "lucide-react";
import { getFirestore, doc, getDoc } from "firebase/firestore";
import app from "../firebase-config";
import { id_firebase } from "../content-site";
import WhatsAppContactPicker from "./WhatsAppContactPicker";
import { WHATSAPP_CONTACTS } from "../utils/whatsappContacts";

const firestore = getFirestore(app);

export default function CTASection() {
    const [revenda, setRevenda] = useState({});

    useEffect(() => {
        const fetchRevenda = async () => {
            try {
                const docRef = doc(firestore, "revenda", id_firebase);
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setRevenda(docSnap.data());
                }
            } catch (error) {
                console.error("Erro ao buscar dados da revenda:", error);
            }
        };

        fetchRevenda();
    }, []);

    return (
        <section className="py-24 bg-background relative overflow-hidden">
            <div className="absolute inset-0 bg-gradient-to-br from-primary/5 via-transparent to-transparent" />
            <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-primary/5 rounded-full blur-3xl" />

            <div className="container mx-auto px-6 relative z-10">
                <div className="max-w-4xl mx-auto text-center">
                    <span className="inline-block px-4 py-2 mb-6 text-sm font-semibold tracking-widest uppercase text-primary border border-primary/30 rounded-full">
                        Pronto para negociar?
                    </span>

                    <h2 className="text-display text-4xl md:text-5xl lg:text-6xl font-bold text-foreground mb-6">
                        Encontre o Caminhão <span className="text-primary">Ideal</span> Para Você
                    </h2>

                    <p className="text-lg md:text-xl text-muted-foreground mb-12 max-w-2xl mx-auto">
                        Nossa equipe está pronta para ajudar você a encontrar o veículo perfeito
                        para o seu negócio. Entre em contato agora mesmo!
                    </p>

                    <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
                        <WhatsAppContactPicker
                            title="Escolha um contato"
                            subtitle="Abra uma conversa com Marta ou Robson."
                            message={`Olá, quero falar com a equipe da ${revenda.penome_fantasia || "revenda"}.`}
                            triggerClassName="inline-flex items-center justify-center rounded-lg bg-primary px-6 py-3 text-lg font-medium text-primary-foreground hover:opacity-90 transition-colors"
                            ariaLabel="Abrir contato de Marta"
                        >
                            <Phone className="mr-2 h-5 w-5" />
                            {WHATSAPP_CONTACTS[0].name}
                        </WhatsAppContactPicker>

                        <WhatsAppContactPicker
                            title="Escolha um contato"
                            subtitle="Abra uma conversa com Marta ou Robson."
                            message={`Olá, quero falar com a equipe da ${revenda.penome_fantasia || "revenda"}.`}
                            triggerClassName="inline-flex items-center justify-center rounded-lg bg-transparent px-6 py-3 text-lg font-medium text-primary border border-primary/30 hover:bg-primary/10 transition-colors"
                            ariaLabel="Abrir opções de WhatsApp"
                        >
                            <MessageCircle className="mr-2 h-5 w-5" />
                            WhatsApp
                        </WhatsAppContactPicker>
                    </div>

                    <div className="grid md:grid-cols-3 gap-6">
                        <div className="p-6 bg-card rounded-lg border border-border/50 card-shadow hover:border-primary/50 transition-all duration-300">
                            <Phone className="w-8 h-8 text-primary mx-auto mb-4" />
                            <h4 className="font-bold text-foreground mb-2">Contatos</h4>
                            <div className="text-muted-foreground space-y-1">
                                <p>{WHATSAPP_CONTACTS[0].name} - {WHATSAPP_CONTACTS[0].displayPhone}</p>
                                <p>{WHATSAPP_CONTACTS[1].name} - {WHATSAPP_CONTACTS[1].displayPhone}</p>
                            </div>
                        </div>
                        <div className="p-6 bg-card rounded-lg border border-border/50 card-shadow hover:border-primary/50 transition-all duration-300">
                            <MessageCircle className="w-8 h-8 text-primary mx-auto mb-4" />
                            <h4 className="font-bold text-foreground mb-2">WhatsApp</h4>
                            <div className="text-muted-foreground space-y-1">
                                <p>{WHATSAPP_CONTACTS[0].name} - {WHATSAPP_CONTACTS[0].displayPhone}</p>
                                <p>{WHATSAPP_CONTACTS[1].name} - {WHATSAPP_CONTACTS[1].displayPhone}</p>
                            </div>
                        </div>
                        <div className="p-6 bg-card rounded-lg border border-border/50 card-shadow hover:border-primary/50 transition-all duration-300">
                            <MapPin className="w-8 h-8 text-primary mx-auto mb-4" />
                            <h4 className="font-bold text-foreground mb-2">Endereço</h4>
                            <p className="text-muted-foreground">
                                {revenda.peendereco_fiscal && `${revenda.peendereco_fiscal}, ${revenda.peendereco_fiscal_numero || ''} – ${revenda.pebairro_fiscal || ''}`}
                                {revenda.pecidade && ` - ${revenda.pecidade}`}
                                {revenda.peuf && ` - ${revenda.peuf}`}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
